import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { UserProvider } from './contexts/UserContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Assessment from './pages/Assessment';
import Questionnaire from './pages/Questionnaire';
import Treatments from './pages/Treatments';
import Progress from './pages/Progress';
import HearingTest from './pages/HearingTest';
import MyResults from './pages/MyResults';

function App() {
  return (
    <UserProvider>
      <ToastProvider>
        <Router>
          <div className="min-h-screen bg-auris-grey flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/assessment" element={<Assessment />} />
                <Route path="/questionnaire" element={<Questionnaire />} />
                <Route path="/treatments" element={<Treatments />} />
                <Route path="/progress" element={<Progress />} />
                <Route path="/hearing-test" element={<HearingTest />} />
                <Route path="/my-results" element={<MyResults />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ToastProvider>
    </UserProvider>
  );
}

export default App;
